/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { IconBackhoe, IconClick, IconDeviceFloppy } from '@tabler/icons-react';
import {
  ActionIcon,
  Button,
  Grid,
  Group,
  Input,
  Modal,
  Paper,
  SegmentedControl,
  Space,
  TextInput,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { EntityEquipmentType } from '../../../../../../../models/core/entities.type';
import { EquipmentType } from '../../../../../../../models/core/equipment.type';
import { buildFakeAuditObject, newGuid } from '../../../../../../../utils/helper.utils';
import EquipmentFormSearch from './EquipmentFormSearch';
import theme from '../../../../../../../theme';
import { Action } from '../../../../../../../models/core/core.type';

type FormViewData = {
  action: Action;
  id: string;
  equipamento: string;
  proprio: string;
};

type FormViewProps = {
  items: EntityEquipmentType[] | null;
  origItem: EntityEquipmentType | null;
  item: EntityEquipmentType | null;
  idEntidade: number | undefined;
  callback(item: EntityEquipmentType | null, action: string, confirmed: boolean): void;
  zIndex: number;
};

export default function EquipmentFormAddEdit(props: FormViewProps) {
  const [opened, setOpened] = useState(false);
  const [equipmentItem, setEquipmentItem] = useState<EquipmentType | null>(
    props.item ? { ...props.item, descricao: props.item.residuoEquipamentoDescricao } : null
  );

  const form = useForm<FormViewData>({
    initialValues: {
      action: props.origItem ? Action.Nothing : Action.Add,
      id: props.item?.id || newGuid(),
      equipamento: props.item?.residuoEquipamento || '',
      proprio: props.item?.proprio.toString() || true.toString(),
    },
    validate: {
      equipamento: (value) => {
        if (value === '') {
          return 'Campo obrigatório';
        }
        return null;
      },
    },
  });

  const isModified = (): boolean => {
    const origData = `${props.origItem?.idResiduoEquipamento || ''}|${props.origItem?.proprio || ''}`;
    const formData = `${equipmentItem?.idResiduoEquipamento || ''}|${form.values.proprio || ''}`;
    return origData !== formData;
  };

  const confirmActionResult = (item: EquipmentType | null, action: string, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }

    switch (action) {
      case 'procurar':
        setOpened(true);
        break;
      case 'callback':
        setOpened(false);
        setEquipmentItem(item);
        form.values.equipamento = item?.residuoEquipamento || '';
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (values: FormViewData) => {
    if (props.origItem) {
      if (isModified()) {
        values.action = Action.Modify;
      } else {
        values = {
          ...values,
          ...props.origItem,
          proprio: values.proprio,
          action: Action.Nothing,
        };
      }
    }

    const formItem: EntityEquipmentType = {
      ...values,
      ...buildFakeAuditObject(),
      idResiduoEquipamento: equipmentItem!.idResiduoEquipamento,
      residuoEquipamento: equipmentItem!.residuoEquipamento,
      residuoEquipamentoDescricao: equipmentItem!.descricao,
      proprio: values.proprio === true.toString(),
      idEntidade: props.idEntidade || -1,
    };

    props.callback({ ...formItem, action: values.action, id: values.id }, 'callback', true);
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)} noValidate>
      <Paper shadow="xs" p="md" withBorder>
        <Modal
          opened={opened}
          closeOnClickOutside={false}
          closeOnEscape={false}
          onClose={() => setOpened(false)}
          title="Equipamentos - Procurar"
          size="60%"
          zIndex={props.zIndex + 1}
        >
          <EquipmentFormSearch
            itemsIdList={
              props.items?.filter((x) => x.action !== Action.Delete).map((y) => y.idResiduoEquipamento) || []
            }
            idEntidade={props.idEntidade}
            callback={confirmActionResult}
          />
        </Modal>

        <Grid columns={3}>
          <Grid.Col span={2}>
            <TextInput
              leftSection={<IconBackhoe size={15} />}
              rightSection={
                <ActionIcon
                  size="sm"
                  radius="sm"
                  color="primary"
                  style={{ borderColor: theme?.colors?.primary?.[6] }}
                  variant="outline"
                  onClick={() => {
                    setOpened(true);
                  }}
                >
                  <IconClick size={15} color={theme?.colors?.primary?.[6]} />
                </ActionIcon>
              }
              onClick={() => {
                setOpened(true);
              }}
              label="Equipamento"
              placeholder="Selecione..."
              {...form.getInputProps('equipamento')}
              readOnly
              required
            />
          </Grid.Col>
          <Grid.Col span={1}>
            <div>
              <Input.Wrapper label="Tipo" required>
                <div />
              </Input.Wrapper>
              <SegmentedControl
                color="primary"
                data={[
                  { label: 'Próprio', value: true.toString() },
                  { label: 'Terceirizado', value: false.toString() },
                ]}
                {...form.getInputProps('proprio')}
              />
            </div>
          </Grid.Col>
        </Grid>
      </Paper>
      <Space h="xl" />
      <Group justify="right">
        <Button leftSection={<IconDeviceFloppy size={18} />} type="submit">
          Salvar
        </Button>
      </Group>
    </form>
  );
}
